import ExitIntentModal from './ExitIntentModal';

interface ResumeInterviewModalProps {
  isOpen: boolean;
  completedCount: number;
  totalCount: number;
  onContinue: () => void;
  onRestart: () => void;
}

/**
 * VI-594 / VI-551 Resume Interview modal.
 *
 * Shown on the V2 landing page when the candidate returns to the interview
 * link and has partial progress (status `Pending`, answers.length > 0).
 *
 * Visually identical to the VI-585 ExitIntentModal — non-dismissible (no X,
 * no backdrop close, no Escape) per the parent story's AC. Reuses that
 * component as the shell so we don't duplicate styling.
 *
 * Continue Interview -> resume at the next unanswered question.
 * Restart Interview -> start at question 1 (soft restart; upstream answers
 *                      stay in place and get overwritten as the candidate
 *                      re-records).
 */
const ResumeInterviewModal = ({
  isOpen,
  completedCount,
  totalCount,
  onContinue,
  onRestart,
}: ResumeInterviewModalProps) => {
  return (
    <ExitIntentModal
      isOpen={isOpen}
      title="Continue Interview?"
      body={`You previously completed ${completedCount} of ${totalCount} questions. Would you like to continue where you left off?`}
      primaryLabel="Continue Interview"
      secondaryLabel="Restart Interview"
      primaryId="btn-resume-continue-interview-click"
      secondaryId="btn-resume-restart-interview-click"
      onPrimary={onContinue}
      onSecondary={onRestart}
    />
  );
};

export default ResumeInterviewModal;
